var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    fillRule: "nonzero",
    d: "M9.156 12.488a3.313 3.313 0 0 1 3.316-3.31 3.313 3.313 0 0 1 3.316 3.31 3.314 3.314 0 0 1-3.316 3.31 3.312 3.312 0 0 1-3.316-3.31m-1.793 0a5.104 5.104 0 0 0 5.109 5.098 5.103 5.103 0 0 0 5.109-5.098 5.103 5.103 0 0 0-5.11-5.097 5.105 5.105 0 0 0-5.108 5.097m9.226-5.297a1.193 1.193 0 0 0 2.389 0 1.194 1.194 0 0 0-2.389 0M8.452 20.568c-.97-.044-1.497-.204-1.848-.341a3.254 3.254 0 0 1-1.89-1.884c-.591-1.513-.394-8.702-.342-9.865.052-1.14.282-2.182 1.087-2.985.995-.993 2.28-1.478 11.033-1.084 1.144.052 2.186.282 2.993 1.084.995.992 1.487 2.288 1.086 11.008-.043.968-.205 1.493-.342 1.843-.9 2.307-2.972 2.628-11.777 2.224M8.37 2.623c-1.627.074-3.04.472-4.178 1.605-1.144 1.14-1.537 2.558-1.61 4.168-.047 1.006-.314 8.602.462 10.594a5.045 5.045 0 0 0 2.91 2.903c.635.245 1.357.413 2.416.461 8.86.401 12.145.183 13.53-3.364.246-.63.415-1.352.462-2.409.404-8.884-.065-10.81-1.61-12.353-1.225-1.221-2.666-2.053-12.382-1.605"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e638e9331affc17114a258224c11dd1a.svg";
export { ForwardRef as ReactComponent };